(function () {
  const ROOT_SEL = "[data-tiered-discount-bar]";
  const MODAL_SEL = "[data-tiered-discount-modal]";
  const OPEN_SEL = "[data-tiered-discount-open]";
  const CLOSE_SEL = "[data-tiered-discount-close]";
  const OPEN_CLASS = "is-open";
  const NO_ANIM_CLASS = "is-no-anim";

  window.__tdbState = window.__tdbState || {
    activeTierCount: null,
    eligibleCount: null,
    tierCount: null
  };

  function readProgressState(root) {
    if (!root) return null;

    return {
      activeTierCount: Number(root.getAttribute("data-active-tier-count") || 0),
      eligibleCount: Number(root.getAttribute("data-eligible-count") || 0),
      tierCount: Number(root.getAttribute("data-tier-count") || 0)
    };
  }

  function stabilizeProgress(root) {
    const next = readProgressState(root);
    if (!next) return;

    const prev = window.__tdbState;
    const canAnimateIncrease =
      prev.activeTierCount != null &&
      next.activeTierCount > prev.activeTierCount;

    root.classList.toggle(NO_ANIM_CLASS, !canAnimateIncrease);
    window.__tdbState = next;
  }

  function stabilizeProgressBars(context = document) {
    context.querySelectorAll?.(ROOT_SEL).forEach(stabilizeProgress);
  }

  function initProgressObserver() {
    stabilizeProgressBars();

    const target =
      document.querySelector("#MinimogCartDrawer") ||
      document.querySelector("#CartDrawer") ||
      document.querySelector(".m-cart-drawer") ||
      document.body;

    if (!target || target.__tdbObserved) return;
    target.__tdbObserved = true;

    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType !== 1) return;

          if (node.matches?.(ROOT_SEL)) {
            stabilizeProgress(node);
            return;
          }

          stabilizeProgressBars(node);
        });
      });
    }).observe(target, { childList: true, subtree: true });
  }

  function getModalFromTrigger(trigger) {
    const root = trigger && trigger.closest(ROOT_SEL);
    return root ? root.querySelector(MODAL_SEL) : null;
  }

  function moveModalToBody(modal) {
    if (!modal || modal.parentElement === document.body) return;

    const placeholder = document.createComment("tiered-discount-modal");
    modal.__tdbPlaceholder = placeholder;
    modal.parentNode.insertBefore(placeholder, modal);
    document.body.appendChild(modal);
  }

  function restoreModalPosition(modal) {
    const placeholder = modal && modal.__tdbPlaceholder;
    if (!modal || !placeholder || !placeholder.parentNode) return;

    placeholder.parentNode.insertBefore(modal, placeholder);
    placeholder.remove();
    modal.__tdbPlaceholder = null;
  }

  function openModal(modal) {
    if (!modal) return;

    moveModalToBody(modal);
    modal.hidden = false;

    requestAnimationFrame(() => {
      modal.classList.add(OPEN_CLASS);
      const closeButton = modal.querySelector(CLOSE_SEL);
      if (closeButton) closeButton.focus({ preventScroll: true });
    });
  }

  function closeModal(modal) {
    if (!modal) return;

    modal.classList.remove(OPEN_CLASS);
    window.setTimeout(() => {
      if (!modal.classList.contains(OPEN_CLASS)) {
        modal.hidden = true;
        restoreModalPosition(modal);
      }
    }, 180);
  }

  document.addEventListener("click", (event) => {
    const openButton = event.target.closest(OPEN_SEL);
    if (openButton) {
      openModal(getModalFromTrigger(openButton));
      return;
    }

    const closeButton = event.target.closest(CLOSE_SEL);
    if (closeButton) {
      closeModal(closeButton.closest(MODAL_SEL));
    }
  });

  document.addEventListener("keydown", (event) => {
    if (event.key !== "Escape") return;

    document.querySelectorAll(`${MODAL_SEL}.${OPEN_CLASS}`).forEach((modal) => {
      closeModal(modal);
    });
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initProgressObserver);
  } else {
    initProgressObserver();
  }
})();
